'use strict';

var load = require('../util/load');
var extend = require('../util/extend');

var getSignature = function getSignature(wechatSignatureUrl, callback) {
    var xhr = new XMLHttpRequest(),
        url = location.href.split('#')[0];
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            var status = xhr.status,
                data = void 0,
                err = void 0;
            try {
                data = JSON.parse(xhr.responseText);
            } catch (e) {
                err = e;
            }
            if (!data || status < 200 && status >= 300) {
                err = {
                    type: 'Request Error'
                };
            }
            callback(data, err);
        }
    };
    xhr.open("POST", wechatSignatureUrl, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send('url=' + encodeURIComponent(encodeURIComponent(url)));
};

module.exports = function (config, wechatApis, listener) {
    getSignature(config.wechatSignatureUrl, function (data, err) {
        if (err || !data.ret) {
            console.error('WeChat Signature \u83B7\u53D6\u5931\u8D25. msg: ' + (err.type || data.errmsg));
            listener();
            return;
        }
        var signData = data.data;
        load.script(config.wechatScriptUrl, function (error) {
            if (error || !wx) {
                console.error('\u52A0\u8F7D JSSDK \u5931\u8D25. url: ' + (location.protocol + '//' + config.wechatScriptUrl));
                bridge();
                return;
            }
            var isError = false;
            wx.config(extend({
                debug: config.debug,
                jsApiList: wechatApis
            }, signData));
            wx.ready(function () {
                if (!isError) {
                    listener(wx);
                }
            });
            wx.error(function (res) {
                isError = true;
                listener(res);
            });
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ../src/env/wechat.js
// module id = 8
// module chunks = 0 2 4